import { types } from "mobx-state-tree";
import type { Instance, SnapshotIn, SnapshotOut } from "mobx-state-tree";

export interface BreedInstance extends Instance<typeof Breed> {}
export interface BreedSnapshotIn extends SnapshotIn<typeof Breed> {}
export interface BreedSnapshotOut extends SnapshotOut<typeof Breed> {}

export const Breed = types.model("Breed", {
  id: types.identifier,
  name: types.string,
});
